import { render, staticRenderFns } from "./compatibility.vue?vue&type=template&id=4b34dbbf&scoped=true&"
import script from "./compatibility.vue?vue&type=script&lang=js&"
export * from "./compatibility.vue?vue&type=script&lang=js&"
import style0 from "./compatibility.vue?vue&type=style&index=0&id=4b34dbbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b34dbbf",
  null
  
)

export default component.exports